import React, { memo, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Modal, Button, Alert } from "@toddle-edu/ds-web";
import { useAcademicRecordsModal } from "../../../../context";
import classes from "./SyncFromToddleModal.scss";

const TEST_ID_PREFIX = "transcriptsV3-syncFromToddle";

const SyncFromToddleModal = ({ onSync }) => {
  const { t } = useTranslation();
  const {
    modalInfo: { metadata } = {},
    closeModal,
  } = useAcademicRecordsModal();
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = useCallback(() => {
    setIsChecked(prev => !prev);
  }, []);

  const handleSync = useCallback(() => {
    const { entityType, entityId } = metadata || {};
    closeModal();
    if (onSync) {
      onSync({ entityType, entityId });
    }
  }, [metadata, closeModal, onSync]);

  return (
    <Modal
      onClose={closeModal}
      width="400px"
      height="max-content"
      dsVersion="2.0"
    >
      <Modal.Header
        title={t("transcript:sync_from_toddle")}
        testId={TEST_ID_PREFIX}
      />
      <Modal.Body>
        <div className={classes.bodyContent}>
          <p className="text-body">
            {t("transcript:sync_confirmation_message")}
          </p>
          <Alert
            dsVersion="2.0"
            variant="inline"
            type="error"
            message={t("transcript:sync_understand_action")}
            onChange={handleCheckboxChange}
            isChecked={isChecked}
            testId={`${TEST_ID_PREFIX}-confirmation-checkbox`}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.footerActions}>
          <Button
            dsVersion="2.0"
            variant="neutral"
            type="outlined"
            size="medium"
            onClick={closeModal}
            testId={`${TEST_ID_PREFIX}-cancel`}
          >
            {t("common:cancel")}
          </Button>
          <Button
            dsVersion="2.0"
            variant="progressive"
            type="fill"
            size="medium"
            disabled={!isChecked}
            onClick={handleSync}
            testId={`${TEST_ID_PREFIX}-confirm`}
          >
            {t("common:sync")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

SyncFromToddleModal.propTypes = {
  onSync: PropTypes.func.isRequired,
};

export default memo(SyncFromToddleModal);
